import Cookies from "js-cookie";

const sessionCheck = async (
  endpoint,
  method = "GET",
  data = null,
  stringifyData = true,
  auth_required = true,
  setAlertMessage,
  navigate,
  setLoginState,
  headers = {
    "Content-Type": "application/json",
  },
) => {
  if (headers === null || headers === undefined) headers = {};
  try {
    const options = {
      method,
      headers: headers,
      credentials: "include",
    };
    if (data) {
      options.body = stringifyData ? JSON.stringify(data) : data;
    }
    const response = await fetch(
      `${process.env.REACT_APP_API}${endpoint}`,
      options,
    );
    if (!response.ok) {
      if (response.status === 401) {
      }
      return { body: null, success: false };
    }

    return { body: await response.json(), success: true };
  } catch (error) {
    if (
      error.message === "Failed to fetch" ||
      error.message === "NetworkError"
    ) {
      navigate("/maintainance");
    } else {
      navigate("/");
      setAlertMessage("Please login again.");
    }
    setLoginState(false);
    return { body: null, success: false };
  }
};

export default sessionCheck;
